import { z } from "zod";
import { webhookEventSchema } from "./webhook-event.js";

export const updateWebhookSchema = z
	.object({
		name: z.string().trim().min(1).max(120).optional(),
		url: z
			.url()
			.refine((value) => value.startsWith("https://"), { message: "URL must use HTTPS" })
			.optional(),
		events: z.array(webhookEventSchema).min(1).optional(),
		is_active: z.boolean().optional(),
	})
	.strict();

export type UpdateWebhookPayload = z.infer<typeof updateWebhookSchema>;
